"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[587],{

/***/ 20587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ withLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/layout/index.js
var layout = __webpack_require__(97183);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./src/constants/logicalGroupChannelCode.ts
var logicalGroupChannelCode = __webpack_require__(85760);
// EXTERNAL MODULE: ./src/constants/region.ts
var region = __webpack_require__(7951);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/constants/layout.ts
var constants_layout = __webpack_require__(435);
;// CONCATENATED MODULE: ./src/components/Common/Footer/Footer.tsx



var FooterLite = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3003).then(__webpack_require__.bind(__webpack_require__, 73003));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73003)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var FooterNtl = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8401).then(__webpack_require__.bind(__webpack_require__, 38401));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38401)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var Footer = function(param) {
    var content = param.content;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (content === null || content === void 0 ? void 0 : (ref = content.footer) === null || ref === void 0 ? void 0 : ref.template) === "sunday-retail" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLite, {
                content: content
            }),
            (content === null || content === void 0 ? void 0 : (ref1 = content.footer) === null || ref1 === void 0 ? void 0 : ref1.template) === "ntl" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterNtl, {
                content: content
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
;// CONCATENATED MODULE: ./src/components/Common/Footer/FooterSimple/FooterSimple.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1192px;\n  margin: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: max-content;\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :hover {\n    color: var(--ui-form-input-footer-link-hover-text-color);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 210px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var FooterContainer = (0,styled_components_browser_esm/* default */.ZP)(lib.Container).withConfig({
    componentId: "sc-34df04f1-0"
})(_templateObject());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34df04f1-1"
})(_templateObject1());
var TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34df04f1-2"
})(_templateObject2(), (0,styled_breakpoints.down)("sm"));
var TextBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-34df04f1-3"
})(_templateObject3(), globals/* color.charcoal10 */.$.charcoal10);
var TextLinkBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-34df04f1-4"
})(_templateObject4());
var CopyRightContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-34df04f1-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/Common/Footer/FooterSimple/FooterSimple.tsx




var FooterSimple = function(param) {
    var content = param.content;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                gutter: [
                    16,
                    16
                ],
                justify: "space-between",
                children: [
                    (content === null || content === void 0 ? void 0 : content.copyright) && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyRightContainer, {
                                children: (content === null || content === void 0 ? void 0 : content.copyright) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBody, {
                                    level: 7,
                                    children: content === null || content === void 0 ? void 0 : content.copyright
                                })
                            })
                        })
                    }),
                    (content === null || content === void 0 ? void 0 : (ref = content.broker_license) === null || ref === void 0 ? void 0 : ref.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: content === null || content === void 0 ? void 0 : (ref1 = content.broker_license) === null || ref1 === void 0 ? void 0 : ref1.link,
                                target: "blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBody, {
                                    level: 7,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextLinkBody, {
                                        level: 7,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: content === null || content === void 0 ? void 0 : (ref2 = content.broker_license) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.body) === null || ref3 === void 0 ? void 0 : ref3[locale]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: content === null || content === void 0 ? void 0 : (ref4 = content.broker_license) === null || ref4 === void 0 ? void 0 : ref4.license_no
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    (content === null || content === void 0 ? void 0 : (ref5 = content.onlineSellingLicense) === null || ref5 === void 0 ? void 0 : ref5.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: content === null || content === void 0 ? void 0 : (ref6 = content.onlineSellingLicense) === null || ref6 === void 0 ? void 0 : ref6.link,
                                target: "blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBody, {
                                    level: 7,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextLinkBody, {
                                        level: 7,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: content === null || content === void 0 ? void 0 : (ref7 = content.onlineSellingLicense) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.body) === null || ref8 === void 0 ? void 0 : ref8[locale]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: content === null || content === void 0 ? void 0 : (ref9 = content.onlineSellingLicense) === null || ref9 === void 0 ? void 0 : ref9.licenseNo
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var FooterSimple_FooterSimple = (FooterSimple);

;// CONCATENATED MODULE: ./src/components/Common/Footer/RetailFooter.tsx





var SundayFooter = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 58960, 23)).then(function(mod) {
        return mod.Footer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58960)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var RetailFooter = function(param) {
    var content = param.content, footerType = param.footerType;
    switch(footerType){
        case constants_layout/* FOOTER_TYPE.MENU */.K.MENU:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayFooter, {
                company: "TH-SDB"
            });
        case constants_layout/* FOOTER_TYPE.LITE */.K.LITE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayFooter, {
                company: "TH-SDB",
                type: "lite"
            });
        case constants_layout/* FOOTER_TYPE.SIMPLE */.K.SIMPLE:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSimple_FooterSimple, {
                content: content
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};
/* harmony default export */ var Footer_RetailFooter = (RetailFooter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/Common/Header/index.tsx
/* eslint-disable consistent-return */ 




var MenuHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(7131), __webpack_require__.e(6031), __webpack_require__.e(282)]).then(__webpack_require__.bind(__webpack_require__, 10282));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10282)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var PartnerHeader = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3991).then(__webpack_require__.bind(__webpack_require__, 43991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43991)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var ProfileHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1509), __webpack_require__.e(3917), __webpack_require__.e(768), __webpack_require__.e(8837), __webpack_require__.e(5865), __webpack_require__.e(3247), __webpack_require__.e(5518), __webpack_require__.e(1549), __webpack_require__.e(6519), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(1469), __webpack_require__.e(6422), __webpack_require__.e(2873), __webpack_require__.e(7131), __webpack_require__.e(6485), __webpack_require__.e(9474), __webpack_require__.e(6434), __webpack_require__.e(3570), __webpack_require__.e(7434)]).then(__webpack_require__.bind(__webpack_require__, 87434));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87434)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var SimpleHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4456), __webpack_require__.e(1747), __webpack_require__.e(9782), __webpack_require__.e(7572), __webpack_require__.e(9953), __webpack_require__.e(7752), __webpack_require__.e(1549), __webpack_require__.e(3436), __webpack_require__.e(8792), __webpack_require__.e(7131), __webpack_require__.e(6031), __webpack_require__.e(797)]).then(__webpack_require__.bind(__webpack_require__, 30797));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30797)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var Header = function(_param) {
    var type = _param.type, others = (0,_object_without_properties/* default */.Z)(_param, [
        "type"
    ]);
    switch(type){
        case "menu":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuHeader, (0,_object_spread/* default */.Z)({}, others));
        case "profile":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileHeader, (0,_object_spread/* default */.Z)({}, others));
        case "simple":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHeader, (0,_object_spread/* default */.Z)({}, others));
        case "partner":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerHeader, (0,_object_spread/* default */.Z)({}, others));
    }
};
/* harmony default export */ var Common_Header = (Header);

// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Layout/LineBubble.tsx

function LineBubble_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  background-color: #06c755;\n  height: 48px;\n  border-radius: 56px;\n  padding: 0px 16px;\n  cursor: pointer;\n  z-index: 9999;\n  ",
        " {\n    bottom: 12px;\n    right: 12px;\n    width: 48px;\n    padding: 0px;\n  }\n"
    ]);
    LineBubble_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LineBubble_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    LineBubble_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-7d26ff0c-0"
})(LineBubble_templateObject(), (0,styled_breakpoints.down)("md"));
var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-7d26ff0c-1"
})(LineBubble_templateObject1(), globals/* color.white */.$.white);
var LineBubble = function() {
    var text = {
        th: "คุยกับเราผ่าน LINE",
        en: "Chat via LINE "
    };
    var locale = (0,next_router.useRouter)().locale;
    var lg = (0,useBreakpoint/* default */.Z)().lg;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: "http://line.me/ti/p/@easysunday",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            align: "middle",
            justify: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/static/line-bubble-icon.svg",
                    height: 40,
                    width: 40,
                    alt: "line"
                }),
                lg && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    level: 7,
                    children: text[locale]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/withLayout.tsx


function withLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n  background: var(--ui-form-background_page-background-color);\n"
    ]);
    withLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function withLayout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 66.67vh;\n  ",
        "\n  ",
        " {\n    min-height: fit-content;\n  }\n"
    ]);
    withLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var withLayout_Content = layout/* default.Content */.Z.Content;
var withLayout_Container = (0,styled_components_browser_esm/* default */.ZP)(layout/* default */.Z).withConfig({
    componentId: "sc-c0164bec-0"
})(withLayout_templateObject());
var CustomContent = (0,styled_components_browser_esm/* default */.ZP)(withLayout_Content).withConfig({
    componentId: "sc-c0164bec-1"
})(withLayout_templateObject1(), function(param) {
    var contentBackgroundColor = param.contentBackgroundColor;
    return contentBackgroundColor && "background: ".concat(contentBackgroundColor, ";");
}, (0,styled_breakpoints.down)("md"));
var CookieConsent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1696).then(__webpack_require__.bind(__webpack_require__, 31696));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31696)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var SundayIndoFooter = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 58960, 23)).then(function(mod) {
        return mod.IndoFooter;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58960)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var withLayout = function(WrappedComponent) {
    return function(props) {
        var ref, ref1;
        var channelConfig = props.channelConfig, _headerType = props.headerType, headerType = _headerType === void 0 ? constants_layout/* HEADER_TYPE.MENU */.N.MENU : _headerType, _footerType = props.footerType, footerType = _footerType === void 0 ? constants_layout/* FOOTER_TYPE.MENU */.K.MENU : _footerType, user = props.user, contentBackgroundColor = props.contentBackgroundColor, channelPathProps = props.channelPath, _isShowFooter = props.isShowFooter, isShowFooter = _isShowFooter === void 0 ? true : _isShowFooter;
        var content = channelConfig.content;
        var router = (0,next_router.useRouter)();
        var locale = router.locale;
        var channelPath = typeof router.query.channelPath === "object" ? (ref = router.query.channelPath) === null || ref === void 0 ? void 0 : ref[0] : router.query.channelPath || channelPathProps;
        var isUseSundayLayout = logicalGroupChannelCode/* LOGICAL_GROUP_CHANNEL_CODE */.V === logicalGroupChannelCode/* RETAIL_LOGICAL_GROUP_CHANNEL_CODE */.b || !content;
        // default header menu type for unknown channel, 404, 500 page
        var isUseDefaultHeaderType = !channelPath;
        var onChangeLanguage = function(language) {
            if (language !== router.locale) {
                router.replace(router.asPath, router.asPath, {
                    locale: language
                });
            }
        };
        var availableLanguages = content === null || content === void 0 ? void 0 : content.supportedLangs.map(function(lang) {
            return lang.code;
        });
        var ref2 = (0,react.useState)(false), footer = ref2[0], setFooter = ref2[1];
        (0,react.useEffect)(function() {
            setTimeout(function() {
                setFooter(isShowFooter);
            }, 800);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        // Dev-note: to prevent /default/404, /default/500 pre-render error on build time
        if (locale === "default") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                contentBackgroundColor: contentBackgroundColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(withLayout_Container, {
                children: [
                    (content === null || content === void 0 ? void 0 : (ref1 = content.askUsChatbot) === null || ref1 === void 0 ? void 0 : ref1.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LineBubble, {}),
                    !isUseSundayLayout && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Header, {
                                showSwitchLanguage: true,
                                type: "partner",
                                onChangeLanguage: onChangeLanguage,
                                language: locale,
                                theme: "white" // 'orange' | 'white' | 'yellow' | 'grey' | 'coolGreyAndWhite'
                                ,
                                content: content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                                contentBackgroundColor: contentBackgroundColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
                            }),
                            !!footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                                content: content
                            })
                        ]
                    }),
                    isUseSundayLayout && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            region/* REGION */.Xz === region/* REGION_OPTION.TH */.Em.TH && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    headerType === constants_layout/* HEADER_TYPE.PROFILE */.N.PROFILE && channelPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Header, {
                                        showSwitchLanguage: true,
                                        type: constants_layout/* HEADER_TYPE.PROFILE */.N.PROFILE,
                                        onChangeLanguage: onChangeLanguage,
                                        language: locale,
                                        content: content,
                                        isLogin: !!user,
                                        profile: user === null || user === void 0 ? void 0 : user.profile
                                    }),
                                    (headerType === constants_layout/* HEADER_TYPE.MENU */.N.MENU || isUseDefaultHeaderType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Header, {
                                        showSwitchLanguage: true,
                                        type: constants_layout/* HEADER_TYPE.MENU */.N.MENU,
                                        onChangeLanguage: onChangeLanguage,
                                        language: locale,
                                        content: content
                                    }),
                                    headerType === constants_layout/* HEADER_TYPE.SIMPLE */.N.SIMPLE && channelPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Header, {
                                        showSwitchLanguage: true,
                                        type: constants_layout/* HEADER_TYPE.SIMPLE */.N.SIMPLE,
                                        onChangeLanguage: onChangeLanguage,
                                        language: locale,
                                        content: content
                                    })
                                ]
                            }),
                            region/* REGION */.Xz === region/* REGION_OPTION.ID */.Em.ID && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Header, {
                                showSwitchLanguage: true,
                                type: "indo",
                                onChangeLanguage: onChangeLanguage,
                                language: locale,
                                theme: "white" // 'orange' | 'white' | 'yellow' | 'grey' | 'coolGreyAndWhite'
                                ,
                                availableLanguages: availableLanguages
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                                contentBackgroundColor: contentBackgroundColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
                            }),
                            region/* REGION */.Xz === region/* REGION_OPTION.TH */.Em.TH && footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_RetailFooter, {
                                content: content,
                                footerType: footerType
                            }),
                            region/* REGION */.Xz === region/* REGION_OPTION.ID */.Em.ID && footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayIndoFooter, {
                                company: "ID-SDI"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent, {})
                        ]
                    })
                ]
            })
        });
    };
};


/***/ }),

/***/ 435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ FOOTER_TYPE; },
/* harmony export */   "N": function() { return /* binding */ HEADER_TYPE; }
/* harmony export */ });
var HEADER_TYPE = {
    MENU: "menu",
    PARTNER: "partner",
    PROFILE: "profile",
    SIMPLE: "simple"
};
var FOOTER_TYPE = {
    MENU: "menu",
    SIMPLE: "simple",
    LITE: "lite"
};


/***/ }),

/***/ 85760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ LOGICAL_GROUP_CHANNEL_CODE; },
/* harmony export */   "b": function() { return /* binding */ RETAIL_LOGICAL_GROUP_CHANNEL_CODE; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var LOGICAL_GROUP_CHANNEL_CODE = "RET" || 0;
var RETAIL_LOGICAL_GROUP_CHANNEL_CODE = "RET";


/***/ }),

/***/ 7951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DW": function() { return /* binding */ MOBILE_NO_PATTERN; },
/* harmony export */   "Em": function() { return /* binding */ REGION_OPTION; },
/* harmony export */   "Oe": function() { return /* binding */ NATIONALITY_FOR_CID; },
/* harmony export */   "Xz": function() { return /* binding */ REGION; },
/* harmony export */   "z0": function() { return /* binding */ CID_PATTERN; }
/* harmony export */ });
/* unused harmony export CONFIG_BY_REGION */
/* harmony import */ var src_utils_master_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26797);
/* harmony import */ var src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1982);
var ref, ref1, ref2;


var REGION = ("TH" || 0).toUpperCase();
var REGION_OPTION = {
    TH: "TH",
    ID: "ID"
};
var CONFIG_BY_REGION = {
    TH: {
        mobileNoPattern: src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .TH_MOBILE_NO_PATTERN */ .bx,
        nationalityForCid: src_utils_master_data__WEBPACK_IMPORTED_MODULE_1__.nationality.THAI.name.code,
        cidPattern: src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .TH_CID_PATTERN */ .lJ
    },
    ID: {
        mobileNoPattern: src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .ID_MOBILE_NO_PATTERN */ .OZ,
        nationalityForCid: src_utils_master_data__WEBPACK_IMPORTED_MODULE_1__.nationality.INDONESIA.name.code,
        cidPattern: src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .ID_CID_PATTERN */ .SY
    }
};
var MOBILE_NO_PATTERN = ((ref = CONFIG_BY_REGION[REGION]) === null || ref === void 0 ? void 0 : ref.mobileNoPattern) || src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .ACCEPT_ALL_PATTERN */ .cS;
var NATIONALITY_FOR_CID = (ref1 = CONFIG_BY_REGION[REGION]) === null || ref1 === void 0 ? void 0 : ref1.nationalityForCid;
var CID_PATTERN = ((ref2 = CONFIG_BY_REGION[REGION]) === null || ref2 === void 0 ? void 0 : ref2.cidPattern) || src_utils_regEx__WEBPACK_IMPORTED_MODULE_0__/* .ACCEPT_ALL_PATTERN */ .cS;


/***/ }),

/***/ 60082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ color; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var color = {
    blueLandingPageBG: "#0857C3",
    carrotOrange: "#FA4616",
    carrotOrange01: "#FFB29E",
    carrotOrange03: "#FA4616",
    carrotOrange04: "#FFF4EB",
    carrotOrange05: "#FEECE8",
    // coolGrey
    coolGreyCG: "#D9D9D6",
    coolGreyCG1: "#f7f7f7",
    coolGreyCG2: "#F0F0EF",
    coolGreyCG3: "#E8E8E6",
    coolGreyCG6: "#828280",
    coolGreyCG8: "#2B2B2B",
    coolGreyCG9: "#F5F6F7",
    darkGrey: "#4A4A4A",
    // warmGrey
    warmGreyWG2: "#EDEBE8",
    // blue
    frenchBlueFb: "#307FE2",
    frenchBlue04: "#004EAB",
    white: "#fff",
    black: "#000000",
    // black
    black01: "#1D1D1D",
    // yellow
    mustardYellowMy: "#FFAD00",
    warningYellow01: "#FFF5E5",
    warningYellow03: "#FF9900",
    // black charcoal
    charcoal11: "#D9DBDE",
    charcoal10: "#2A2C2E",
    charcoal09: "#54565A",
    charcoal08: "#76777A",
    charcoal07: "#98989A",
    charcoal05: "#C8C8C8",
    charcoal04: "#D9D9D6",
    charcoal03: "#E8E8E6",
    charcoal01: "#F7F7F7",
    errorRed04: "#DA3B45",
    errorRed03: "#BF0000",
    errorRed02: "#D24D4D",
    errorRed01: "#BF000019",
    // orange
    tigerOrange02: "#FF9A36",
    tigerOrange03: "#FF7500",
    // pebble grey
    pebbleGrey: "#707372",
    // success green
    successGreeen01: "#E8F2ED",
    successGreeen03: "#1C7C4E",
    successGreeen04: "#146037",
    // brown
    brownTertiary: "#6F5F5E",
    // beige
    beige100: "#F1EFE3",
    // navy
    navy: "#00294D",
    // green
    pineGreen04: "#02685b",
    successGreen01: "#E8F2ED"
};


/***/ }),

/***/ 1982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FM": function() { return /* binding */ ID_RT_PATTERN; },
/* harmony export */   "G8": function() { return /* binding */ YYYY_MM_DD_DATE_PATTERN; },
/* harmony export */   "J5": function() { return /* binding */ ID_RW_PATTERN; },
/* harmony export */   "OZ": function() { return /* binding */ ID_MOBILE_NO_PATTERN; },
/* harmony export */   "QI": function() { return /* binding */ EMAIL_PATTERN; },
/* harmony export */   "Rc": function() { return /* binding */ ONLY_TH_EN_PATTERN; },
/* harmony export */   "SY": function() { return /* binding */ ID_CID_PATTERN; },
/* harmony export */   "a_": function() { return /* binding */ EN_NUM_SYMBOL; },
/* harmony export */   "bx": function() { return /* binding */ TH_MOBILE_NO_PATTERN; },
/* harmony export */   "cS": function() { return /* binding */ ACCEPT_ALL_PATTERN; },
/* harmony export */   "eL": function() { return /* binding */ DECIMAL_PATTERN; },
/* harmony export */   "lJ": function() { return /* binding */ TH_CID_PATTERN; },
/* harmony export */   "mz": function() { return /* binding */ ONE_TO_HUNDRED_PATTERN; },
/* harmony export */   "rB": function() { return /* binding */ ONLY_EN_NUM_UNDERSCORE_DASH_CHAR_PATTERN; }
/* harmony export */ });
/* unused harmony exports BANK_ACCOUNT_NO_PATTERN, SPLIT_PATH */
var ACCEPT_ALL_PATTERN = /[\s\S]*/;
var TH_MOBILE_NO_PATTERN = /0([689]\d{8}|[23457]\d{7})$/;
var ID_MOBILE_NO_PATTERN = /^(\(\+62|62|0)(\d{2,3})?\)?[ .-]?\d{2,4}[ .-]?\d{2,5}$/;
var DECIMAL_PATTERN = /^\d+(?:\.\d+)?$/;
var TH_CID_PATTERN = /^[1-9]\d{4}\d{5}\d{2}\d$/;
var ID_CID_PATTERN = /^\d{2}[01237]\d{3}[01234567]\d[01]\d{7}$/;
var ONE_TO_HUNDRED_PATTERN = /^[1-9]\d?$|^100$/;
var BANK_ACCOUNT_NO_PATTERN = /^[A-Za-z0-9]+$/;
var EMAIL_PATTERN = // eslint-disable-next-line no-useless-escape
/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var ONLY_TH_EN_PATTERN = /^[a-zA-Z\u0E00-\u0E7F\s]*$/;
var EN_NUM_SYMBOL = /^[a-zA-Z0-9-_]*$/;
var ONLY_EN_NUM_UNDERSCORE_DASH_CHAR_PATTERN = /[^a-zA-Z0-9\-_]/g;
var ID_RW_PATTERN = /^\d{3}$/;
var ID_RT_PATTERN = /^\d{3}$/;
var SPLIT_PATH = /^\/([^/]+)/;
var YYYY_MM_DD_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;


/***/ })

}]);